export default [
    {code:"Industrial", name:"Industrial"},
    {code:"MT Retail", name:"Retail-MT"},
    {code:"Multi-Family", name:"Multi-Family"},
    {code:"Office", name:"Office"},
    {code:"STNL Retail", name:"Retail-STNL"}
];
// They should be in alphabetical order